import { datadogRum } from "@datadog/browser-rum"
import type { DatadogArgs } from "./types"

export function initDatadog({
  applicationId = "9a717536-10d9-4e0d-ad69-d3b536104393",
  clientToken = "pubda68faef706d23f27c9d9c9805c133a5",
  site = "datadoghq.com",
  env = "development",
  version = "0.0.0",
  defaultPrivacyLevel = "mask-user-input",
  sessionSampleRate = 100,
  service = "oyster-frontend",
  trackUserInteractions = true,
  ...rest
}: DatadogArgs) {
  datadogRum.init({
    applicationId,
    clientToken,
    site,
    env,
    version,
    defaultPrivacyLevel,
    sessionSampleRate,
    trackUserInteractions,
    service,
    useSecureSessionCookie: true,
    // This is a workaround for the issue with aborted requests to not be sent to Datadog.
    // See: https://github.com/DataDog/browser-sdk/issues/362
    beforeSend: (_, ctx) => {
      if ("isAborted" in ctx && ctx.isAborted) {
        return false // Prevent sending aborted events
      }
      return true
    },
    ...rest,
  })
}
